<template>
  <div class="d-flex justify-content-center" style="min-width: 200px">
    <base-presigned-image
      class="rounded thumbnail img-size mc__explore-thumbnail"
      :file-id="fileId"
      :default-src="
        videoThumbnailSrc ? videoThumbnailSrc : require('@/assets/default-lu-cover.jpg')
      "
    ></base-presigned-image>
  </div>
</template>

<script>
import LearningUnit from '@/models/LearningUnit';
import BasePresignedImage from '@/components/base-components/BasePresignedImage.vue';

export default {
  name: 'McExploreThumbnail',

  components: {
    BasePresignedImage
  },

  props: {
    learningUnit: {
      type: LearningUnit,
      required: true
    }
  },

  computed: {
    fileId() {
      return this.learningUnit?.media_detail?.[0]?.id;
    },

    videoThumbnailSrc() {
      return this.learningUnit?.media_detail_vimeo?.thumbnail_link;
    }
  }
};
</script>
